import React, { forwardRef } from 'react';

import { Badge, Grid } from '@material-ui/core';

import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import ITopAreaButton from 'src/common/interfaces/dtos/ITopBarButton';
import { IconButton } from 'src/common/components/icon-button/icon-button';

import { styles } from './top-area-button-styles';
import { BaseButton } from '../../common/components/base-button';

const TopAreaButton = forwardRef<HTMLDivElement, ITopAreaButton>(
  (
    {
      onClick,
      enabled,
      icon,
      iconProps,
      enabledIcon: EnabledIcon,
      disabledIcon: DisabledIcon,
      selected,
      notificationText,
      showBadge,
      testId,
      buttonType,
      isMiddle,
      isDisabled,
      cashierPreferences,
    },
    ref,
  ) => {
    const classes = styles({
      textSize: cashierPreferences?.textZoomLevel ?? SizeType.Medium,
      isMiddle,
      selected,
    });

    const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
      event.preventDefault();
      if (onClick !== undefined && enabled !== false) {
        onClick();
      }
    };

    const getIconType = () => (!enabled && DisabledIcon ? DisabledIcon : EnabledIcon);
    const notifyText = notificationText ?? '';
    const isBadgeInvisible = (notifyText !== '' && notifyText !== '0') || !showBadge;
    return (
      <Badge
        badgeContent={notificationText}
        invisible={isBadgeInvisible}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        color='error'
        data-testid={`badge-${testId}`}
        classes={{
          badge: classes.badge,
        }}
      >
        {icon ? (
          <IconButton
            icon={icon || 'Help'}
            iconProps={iconProps}
            buttonType={buttonType}
            onClick={event => {
              handleClick(event);
            }}
            className={classes.buttonContainer}
            data-testid={`top-area-button-${testId}`}
            disabled={isDisabled}
          >
            {ref && <div ref={ref} className={classes.modalAnchor} />}
          </IconButton>
        ) : (
          <BaseButton
            buttonType={buttonType}
            onClick={event => {
              handleClick(event);
            }}
            className={classes.buttonContainer}
            data-testid={`top-area-button-${testId}`}
            disabled={isDisabled}
            isSquare
          >
            {ref && <div ref={ref} className={classes.modalAnchor} />}
            <Grid container alignItems='center' justifyContent='center'>
              {getIconType()}
            </Grid>
          </BaseButton>
        )}
      </Badge>
    );
  },
);

TopAreaButton.displayName = 'TopAreaButton';

export default TopAreaButton;
